<script setup lang="ts">
import { CloudUpload, LoaderCircle, RefreshCw, X } from 'lucide-vue-next';
import {
  offlineQueueDisplayCount, offlineQueueError, offlineQueuePreviewActive, offlineQueueUploading,
  retryOfflineQueue, setOfflineQueuePreview,
} from '../composables/offline-queue';

withDefaults(defineProps<{ respectTopSafeArea?: boolean; sticky?: boolean }>(), {
  respectTopSafeArea: true,
  sticky: false,
});
</script>

<template>
  <div v-if="offlineQueueDisplayCount" class="offline-ribbon" :class="{ 'safe-area-top': respectTopSafeArea, sticky }" role="status">
    <div class="offline-ribbon-copy">
      <CloudUpload :size="18" />
      <span><strong>{{ offlineQueueDisplayCount }} {{ offlineQueueDisplayCount === 1 ? 'registro pendiente' : 'registros pendientes' }}</strong><small v-if="offlineQueuePreviewActive">Vista de prueba · Se subirán automáticamente cuando haya internet.</small><small v-else-if="offlineQueueError">{{ offlineQueueError }}</small><small v-else>Se subirán automáticamente cuando haya internet.</small></span>
    </div>
    <button v-if="offlineQueuePreviewActive" type="button" @click="setOfflineQueuePreview(false)">
      <X :size="16" /> Cerrar prueba
    </button>
    <button v-else type="button" :disabled="offlineQueueUploading" @click="retryOfflineQueue">
      <LoaderCircle v-if="offlineQueueUploading" :size="16" class="spin" /><RefreshCw v-else :size="16" />
      {{ offlineQueueUploading ? 'Subiendo' : 'Reintentar' }}
    </button>
  </div>
</template>

<style scoped>
.offline-ribbon{position:relative;z-index:950;width:100%;min-height:53px;padding:0 max(14px,env(safe-area-inset-right,0px)) 5px max(14px,env(safe-area-inset-left,0px));display:flex;align-items:center;justify-content:flex-start;gap:24px;color:#7f1d2d;background:#ffd9de;box-shadow:0 1px 0 rgba(127,29,45,.16)}
.offline-ribbon.sticky{position:sticky;top:0}
.offline-ribbon.safe-area-top{min-height:calc(53px + env(safe-area-inset-top,0px));padding-top:env(safe-area-inset-top,0px)}
.offline-ribbon-copy{min-width:0;display:flex;align-items:center;gap:9px}.offline-ribbon-copy>svg{flex:none}.offline-ribbon-copy>span{min-width:0;display:flex;align-items:baseline;gap:9px}.offline-ribbon strong{font-size:13.75px}.offline-ribbon small{overflow:hidden;color:#98404c;font-size:11.25px;text-overflow:ellipsis;white-space:nowrap}
.offline-ribbon button{min-height:40px;margin-left:auto;padding:0 14px;display:flex;align-items:center;gap:8px;flex:none;border:1px solid rgba(127,29,45,.22);border-radius:10px;color:#7f1d2d;background:rgba(255,255,255,.52);font-size:12.5px;font-weight:850;cursor:pointer}.offline-ribbon button:disabled{cursor:wait;opacity:.75}.spin{animation:spin .8s linear infinite}@keyframes spin{to{transform:rotate(360deg)}}
@media(max-width:620px){.offline-ribbon{justify-content:space-between;gap:10px}.offline-ribbon-copy>span{display:grid;gap:1px}.offline-ribbon small{max-width:48vw}.offline-ribbon button{padding:0 11px}}
.offline-ribbon button{font-size:var(--webapp-action-font-size)}
</style>
